import { createTheme } from '@mui/material/styles'
export const theme = createTheme({
  palette: {
    primary: {
      main: '#1329FE',
      dark: '#1329FE',
      light: '#CFDDF8',
    },
    text: {
      primary: '#1E2127',
      secondary: '#B6B6B6',
      darkSecondary: '#5F6368',
    },
    error: {
      main: '#EC3737',
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        sizeSmall: {
          padding: '0.5rem',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          textTransform: 'none',
        },
      },
    },
  },
  typography: {
    overline: {
      fontSize: '0.625rem',
      lineHeight: '0.75rem',
      fontWeight: 'bold',
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
    },
    root: {
      color: '#202124',
    },
    colorTextSecondary: {
      color: '#B6B6B6',
    },
    colorSecondary: {
      color: '#808080',
    },
    h1: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: '1.43475rem',
    },
    h2: {
      fontSize: '1.125rem',
      fontWeight: 500,
      lineHeight: '1.3125rem',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
    },
  },
})

export default theme
